// Normaliza fotos del móvil antes de subirlas: añade extensión si falta y convierte a JPEG
// las imágenes en formatos no admitidos (p. ej. WebP) o de más de 10 MB.
const LIMITE = 10 * 1024 * 1024;
const LADO_MAX = 2400;
const EXT_OK = /\.(pdf|jpe?g|png)$/i;
const MIME_EXT = { "image/jpeg": "jpg", "image/png": "png", "application/pdf": "pdf" };

const aJpeg = async (file) => {
  const bmp = await createImageBitmap(file);
  const k = Math.min(1, LADO_MAX / Math.max(bmp.width, bmp.height));
  const c = document.createElement("canvas");
  c.width = Math.round(bmp.width * k);
  c.height = Math.round(bmp.height * k);
  c.getContext("2d").drawImage(bmp, 0, 0, c.width, c.height);
  const blob = await new Promise((res) => c.toBlob(res, "image/jpeg", 0.85));
  if (!blob) throw new Error("conversión");
  return new File([blob], `foto-${Date.now()}.jpg`, { type: "image/jpeg" });
};

export const prepararArchivo = async (file) => {
  const esImagen = (file.type || "").startsWith("image/");
  const admitido = EXT_OK.test(file.name) || MIME_EXT[file.type];
  if (admitido && file.size <= LIMITE) {
    if (EXT_OK.test(file.name)) return file;
    return new File([file], `foto-${Date.now()}.${MIME_EXT[file.type]}`, { type: file.type });
  }
  if (!esImagen) return file;
  try { return await aJpeg(file); } catch { return file; }
};
